<header class="flex p-6">
  <div class="flex w-full">
    @for (step of steps.toArray() | slice:0:steps.length-1; track step; let i = $index) {
      <div (click)="selectStepByIndex(i)" class="flex w-full items-center">
        @if (i !== steps.length - 1) {
          <a class="inline-flex items-center justify-center transparent cursor-pointer" [class.active]="selectedIndex === i">
            {{step.label}}
          </a>
        }
        <span class="flex-grow mx-2">
          @if (i !== steps.length - 1) {
            <hr/>
          }
        </span>
      </div>
    }
    <div (click)="selectStepByIndex(steps.length - 1)" class="flex items-center">
      <a class="transparent cursor-pointer" [class.active]="selectedIndex === steps.length - 1" >
        {{steps.last.label}}
      </a>
    </div>
  </div>
</header>

<ng-container [ngTemplateOutlet]="selected ? selected.content : null"></ng-container>

<footer class="flex justify-end p-6">
  <ng-content select="[button-row]"></ng-content>
</footer>
